import React, { ReactElement } from "react";
import { ICalendarEvent } from "components";
import { IHomeCalendarData } from "../Home";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function renderCounts(e: ICalendarEvent<IHomeCalendarData>): ReactElement {
    if (e.isGroupGap) return null;

    return <div className="calendarUpdateEvent_counts">
        <FontAwesomeIcon icon="hdd" className="calendarUpdateEvent_countsIcon" />
        {e.data.update.counts?.stages?.[e.data.stageIndex]?.total}
    </div>
}